export default {
	国家: '國家',
	前缀: '前置字首',
}
